module.exports = __webpack_public_path__ + "img/Bild 006.290dacb3.jpg";